import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import usePublicationOrder from '@hooks/usePublicationOrder'

const MODAL_KEY = 'RevertPublicationOrderModal'

type ModalCallbacks = {
  closeModal: () => void,
  revertPublicationOrder: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const defaultState = {
  ticket_number: '',
}

const RevertPublicationOrderModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, revertPublicationOrder } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { publicationOrder } = modalPayload

  const [state, setState] = useSetState(defaultState)
  const { ticket_number } = state

  const {
    callbacks: {
      revertPublicationOrder: revertFn,
    },
    updating,
  } = usePublicationOrder(publicationOrder)

  const revertPublicationOrderPayload = {
    callbacks: {
      action: revertFn,
      afterAction: closeModal,
    },
    entityParams: { ticket_number },
    toastText: 'Orders Reverted to Pending',
    requestOptions: { include_publication_booking_status: true, include_publication_order_bookings: true },
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Revert Order" />
      <SidebarModal.Content>
        <SidebarNoticeBox>
          <SidebarNoticeBox.Title>Are you sure?</SidebarNoticeBox.Title>

          <SidebarNoticeBox.Paragraph>
            This will reset all of the bookings to pending and they will need to be re-booked.
          </SidebarNoticeBox.Paragraph>
        </SidebarNoticeBox>

        <Form>
          <Form.Field direction="column" label="Ticket Number">
            <input
              name="ticket_number"
              onChange={e => setState({ ticket_number: e.target.value })}
              type="text"
              value={ticket_number}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryDestroy"
          loading={updating}
          // @ts-expect-error TS2345
          onClick={() => revertPublicationOrder(revertPublicationOrderPayload)}
          size="large"
        >
          Revert
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <RevertPublicationOrderModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
